// Recarga el front cuando se despliega una version nueva. Cada build cambia el hash del bundle principal
// (main.<hash>.js) en index.html, que nginx sirve sin cache: si el publicado no es el que esta corriendo,
// hay version nueva. Para no perder lo que el usuario esta escribiendo, la recarga ocurre en la siguiente
// navegacion dentro de la app (la pagina de destino se carga del servidor), nunca a mitad de un formulario.

const INTERVALO_REVISION_MS = 5 * 60 * 1000;
const PATRON_BUNDLE = /<script[^>]+src="([^"]*main[.-][^"]+\.js)"/;

/** src del bundle principal en un index.html, o null si no tiene hash (desarrollo) */
export const bundleDeIndex = (html) => {
  const encontrado = PATRON_BUNDLE.exec(html || "");
  return encontrado ? encontrado[1] : null;
};

export const hayVersionNueva = (bundleActual, htmlPublicado) => {
  const publicado = bundleDeIndex(htmlPublicado);
  return Boolean(bundleActual && publicado && publicado !== bundleActual);
};

export const vigilarVersionNueva = () => {
  const bundleActual = bundleDeIndex(document.documentElement.outerHTML);
  // En desarrollo (yarn start) no hay bundle con hash: no hay nada que vigilar
  if (!bundleActual) return;

  let pendiente = false;

  const revisar = async () => {
    if (pendiente) return;
    try {
      const respuesta = await fetch("/index.html", { cache: "no-store" });
      if (respuesta.ok && hayVersionNueva(bundleActual, await respuesta.text())) {
        pendiente = true;
      }
    } catch (e) {
      // Sin red o servidor no disponible: se reintenta en la siguiente revision
    }
  };

  // React Router navega con history.pushState; atras/adelante disparan popstate
  const pushStateOriginal = window.history.pushState;
  window.history.pushState = function (...args) {
    pushStateOriginal.apply(this, args);
    if (pendiente) window.location.reload();
  };
  window.addEventListener("popstate", () => {
    if (pendiente) window.location.reload();
  });

  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") revisar();
  });
  setInterval(revisar, INTERVALO_REVISION_MS);
};
